// extracted by mini-css-extract-plugin
export var button = "_cf-0";
export var donut = "_cf-1";
export var donutFill = "_cf-3";
export var donutTrack = "_cf-2";